var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12H3.11111M12 2V3.11111M20.8889 12H22M4.88889 4.88889L5.66667 5.66667M19.1111 4.88889L18.3333 5.66667M9.44466 17.5556H14.5558M8.66667 16.4444C7.73386 15.7448 7.04481 14.7695 6.69715 13.6565C6.34948 12.5435 6.36081 11.3494 6.72954 10.2432C7.09826 9.137 7.80569 8.17488 8.75161 7.4931C9.69753 6.81132 10.834 6.44444 12 6.44444C13.166 6.44444 14.3025 6.81132 15.2484 7.4931C16.1943 8.17488 16.9017 9.137 17.2705 10.2432C17.6392 11.3494 17.6505 12.5435 17.3029 13.6565C16.9552 14.7695 16.2661 15.7448 15.3333 16.4444C14.8995 16.8739 14.5729 17.3994 14.3799 17.9785C14.1868 18.5576 14.1328 19.174 14.2222 19.7778C14.2222 20.3671 13.9881 20.9324 13.5713 21.3491C13.1546 21.7659 12.5894 22 12 22C11.4106 22 10.8454 21.7659 10.4287 21.3491C10.0119 20.9324 9.77778 20.3671 9.77778 19.7778C9.86717 19.174 9.81317 18.5576 9.62014 17.9785C9.42711 17.3994 9.10048 16.8739 8.66667 16.4444Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.a545dce97a1a25c46f4564629dd9985b.svg";
export { ForwardRef as ReactComponent };